import './BrandMark.css';

/**
 * Marque digiTRANS statique : le logo que le loader trace en roulant
 * (deux roues, châssis, deux passagers). Couleurs lues dans les tokens du thème.
 * @param {number} size  Hauteur en px
 */
export function BrandMark({ size = 28, className = '', title }) {
  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      viewBox="150 12 540 335"
      height={size}
      width={(size * 540) / 335}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : 'true'}
      focusable="false"
    >
      <g className="brand-mark__ink" fill="none" strokeLinecap="round">
        <circle cx="230" cy="262" r="55" strokeWidth="26" />
        <circle cx="608" cy="262" r="55" strokeWidth="26" />
        <path d="M325 275Q410 282 470 252Q495 240 508 232" strokeWidth="22" />
        <path d="M328 208C322 130 335 90 355 90C375 90 388 140 396 202" strokeWidth="22" />
        <path d="M438 185C435 120 442 90 458 90C478 90 498 140 510 176" strokeWidth="22" />
      </g>
      <circle className="brand-mark__dot" cx="510" cy="234" r="13" />
      <g className="brand-mark__accent">
        <rect x="325" y="22" width="37" height="38" rx="2" />
        <rect x="440" y="35" width="25" height="25" rx="2" />
      </g>
    </svg>
  );
}
